import { addModal, removeModal } from '~/stores/modal';
import { useInsertSeedImagesMutation } from './urql';

export const useProductModals = () => {
    const client = useUser() as Ref<any>;
    const { executeMutation: insertImages } = useInsertSeedImagesMutation();

    const maybeActionModal = (options:any) => {
        if (!client.value?.client_id) {
            addModal({
                title: 'Войдите в аккаунт',
                body: 'Данное действие доступно только авторизированным пользователям <br><br><a class="button bg-green-600 text-white" href="/auth/signin">Войти</a>'
            });
        } else {
            addModal(options);
        }
    }

    // TODO provide actionHandlers
    return {
        imagesModal(seed_id:number) {
            const busy = ref(false);
            maybeActionModal({
                title: 'Добавить фотографии',
                class: 'uo-photo-upload-modal',
                canClose: () => !busy.value,
                component: defineAsyncComponent(() => import('@/components/Modals/PhotoUpload.vue')),
                componentProps: {
                    onBusy: (value:boolean) => { busy.value = value; },
                    async saveImages(images:any[]) {
                        const objects = images.map(it => ({ seed_id, uuid: it.uuid }));
                        const result = await insertImages({ objects }, {additionalTypenames:['uogorod_seeds']});
                        if (result.error) throw result.error;
                    },
                },
                events: {saved() { removeModal(); }},
            });
        },
        similarModal(seed_id:number, seed_category_id:number) {
            maybeActionModal({
                component: defineAsyncComponent(() => import('@/components/Modals/SeedSimilar.vue')),
                componentProps: {
                    // multiple: true,
                    seed_id,
                    seed_category_id
                }
            })
        },
        recordModal(seed_id:number) {
            maybeActionModal({
                component: defineAsyncComponent(() => import('@/components/Modals/SeedRecord.vue')),
                componentProps: {
                    seed_id,
                }
            })
        },
        reviewModal({ title, id: seed_id, reviews=[], taskId, initialRate, onSaved, getSuggestions }: any) {
            const busy=ref(false);
            // TODO может модалка может отдавать некоторые методы наружу
            const modal = maybeActionModal({
                class: 'uo-seed-review-modal',
                component: defineAsyncComponent(() => import('@/components/Modals/PlantReviewFlow.vue')),
                canClose: () => !busy.value,
                events: {},
                actions: [],
                componentProps: {
                    plant: {seed_id,title,taskId}, initialRate,
                    afterSave: async(receipt:any)=>{await onSaved?.(receipt);return getSuggestions?.();},
                    onBusy: (value:boolean)=>{busy.value=value;}
                }
            })
        }
    }
}
